import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "oauth-wrapper" }
const _hoisted_2 = { class: "form-fields" }
const _hoisted_3 = { class: "form-actions" }
const _hoisted_4 = { class: "remember-row" }
const _hoisted_5 = { class: "footer-text" }

import { reactive } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import AuthLayout from "@/components/auth/AuthLayout.vue";
import OAuthButtons from "@/components/auth/OAuthButtons.vue";
import BaseInput from "@/components/ui/BaseInput.vue";
import BaseButton from "@/components/ui/BaseButton.vue";
import BaseCheckbox from "@/components/ui/BaseCheckbox.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SignInView',
  setup(__props) {

const router = useRouter();
const authStore = useAuthStore();

const form = reactive({
  email: "",
  password: "",
  remember: false,
});

const errors = reactive({
  email: "",
  password: "",
});

function validate() {
  let valid = true;
  errors.email = "";
  errors.password = "";

  if (!form.email.trim()) {
    errors.email = "Required";
    valid = false;
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
    errors.email = "Invalid email";
    valid = false;
  }

  if (!form.password) {
    errors.password = "Required";
    valid = false;
  }

  return valid;
}

function handleOAuth(provider: string) {
  return provider;
}

function handleSubmit() {
  if (!validate()) return;
  authStore.login();
  router.push("/dashboard");
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(AuthLayout, {
    label: "Welcome Back",
    title: "Sign in to your account",
    subtitle: "Access your dashboard and manage your projects"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(OAuthButtons, { onOauth: handleOAuth })
      ]),
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "divider" }, [
        _createElementVNode("div", { class: "divider-line" }),
        _createElementVNode("span", { class: "divider-text" }, "Or continue with email"),
        _createElementVNode("div", { class: "divider-line" })
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(BaseInput, {
          modelValue: form.email,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.email) = $event)),
          label: "Email address",
          type: "email",
          placeholder: "you@example.com",
          icon: "mail",
          error: errors.email
        }, null, 8, ["modelValue", "error"]),
        _createVNode(BaseInput, {
          modelValue: form.password,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.password) = $event)),
          label: "Password",
          type: "password",
          placeholder: "Enter your password",
          icon: "lock",
          error: errors.password
        }, null, 8, ["modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(BaseCheckbox, {
            modelValue: form.remember,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.remember) = $event))
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("Remember me", -1)
            ]))]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_RouterLink, {
            to: "/forgot-password",
            class: "forgot-link"
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode(" Forgot password? ", -1)
            ]))]),
            _: 1
          })
        ]),
        _createVNode(BaseButton, {
          type: "submit",
          onClick: handleSubmit
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createTextVNode("Sign in", -1)
          ]))]),
          _: 1
        }),
        _createElementVNode("p", _hoisted_5, [
          _cache[7] || (_cache[7] = _createTextVNode(" Don't have an account? ", -1)),
          _createVNode(_component_RouterLink, { to: "/sign-up" }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode("Create one", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})